import CryptoJS from "crypto-js";

const SECRET_KEY =
  process.env.REACT_APP_STORAGE_SECRET;

export const encryptData = (data) => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  } catch {
    return null;
  }
};

export const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch {
    return null;
  }
};

export const setEncryptedItem = (key, value) => {
  try {
    localStorage.setItem(key, encryptData(value));
  } catch {}
};

export const getDecryptedItem = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return decryptData(raw);
  } catch {
    return null;
  }
};

export const removeStorageItem = (key) => {
  localStorage.removeItem(key);
};

// Custom redux-persist storage engine — persisted state is already a JSON string,
// so we encrypt/decrypt that string directly without an extra JSON pass.
export const encryptedStorage = {
  getItem: (key) =>
    new Promise((resolve) => {
      try {
        const raw = localStorage.getItem(key);
        if (!raw) return resolve(null);
        const bytes = CryptoJS.AES.decrypt(raw, SECRET_KEY);
        resolve(bytes.toString(CryptoJS.enc.Utf8) || null);
      } catch {
        // Corrupted or old unencrypted data — let redux-persist start fresh
        resolve(null);
      }
    }),

  setItem: (key, value) =>
    new Promise((resolve) => {
      try {
        const encrypted = CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
        localStorage.setItem(key, encrypted);
      } catch {}
      resolve();
    }),

  removeItem: (key) =>
    new Promise((resolve) => {
      localStorage.removeItem(key);
      resolve();
    }),
};
